import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from '../../Styles/Modules/Button.module.scss';
import { playSound } from '../../State/Slices/soundsSlice';
import { SOUND_NAME } from '../../sounds';

const Button = ({
  action,
  title,
  icon: Icon,
  disabled,
  modifier,
  text,
  noCredits,
  active
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <button
      className={`${styles.button} ${modifier ? styles[modifier] : ''} ${active ? styles.buttonActive : ''}`}
      onClick={() => {
        dispatch(playSound(noCredits ? SOUND_NAME.noCredits : SOUND_NAME.click));
        action && dispatch(action());
      }}
      disabled={disabled}
      title={t(title)}
    >
      {t(text)}
      {Icon && <Icon className={styles.buttonIcon}/>}
    </button>
  );
};

export default Button;
